const Data = [
  {
    id: 1,
    title: "tribute to naruto uzumaki",
    des: "a single page project which is about a fictional character named naruto uzumaki and his ninja way!!😁",
    language: "html",
    link: "https://harikarumuri.github.io/tribute-to-narutouzumaki/",
    image:
      "https://cdn.vox-cdn.com/thumbor/UswYUb9Ve-sg9EN1f0KMAkOUizE=/0x0:1280x721/1200x800/filters:focal(544x281:748x485)/cdn.vox-cdn.com/uploads/chorus_image/image/70124512/naruto.0.jpg",
  },
  {
    id: 2,
    title: "login page",
    des: "a simple login page!! to show my good work in css 🙌👍",
    language: "CSS",
    link: "https://harikarumuri.github.io/login-page-project3/",
    image:
      "https://static.vecteezy.com/system/resources/thumbnails/001/991/652/small_2x/sign-in-page-flat-design-concept-illustration-icon-account-login-user-login-abstract-metaphor-can-use-for-landing-page-mobile-app-ui-posters-banners-free-vector.jpg",
  },
  {
    id: 3,
    title: "simple Photography page",
    des: "a basic photography page that was created in the early stages of my learning web development and is incomplete🤞😉",
    language: "css",
    link: "https://harikarumuri.github.io/phography-page/",
    image:
      "https://www.upskillist.com/assets/course-cards/website/wide/photography-21.png",
  },
  {
    id: 4,
    title: "form submission",
    des: "Have you tried a form to see what kind of device the user has or uses? 👀✨",
    language: "css",
    link: "https://harikarumuri.github.io/submit-forms/",
    image:
      "https://st3.depositphotos.com/3287005/13699/v/600/depositphotos_136992408-stock-illustration-application-forms-set.jpg",
  },
  {
    id: 5,
    title: "to do app",
    des: "a website that can be used as a to-do list, with decent layout and other features",
    language: "javascript",
    link: "https://harikarumuri.github.io/to-do-app/",
    image:
      "https://media.istockphoto.com/vectors/woman-holding-a-long-todo-list-or-shopping-list-with-checkmarks-vector-id1271149787?k=20&m=1271149787&s=170667a&w=0&h=C1i21c3H7v_JrZKi1laM9Q-mNYVu-VCphBODUianeFw=",
  },
  {
    id: 6,
    title: "fun app",
    des: "It's a game that plays with you, a button that you can't press, and a fun app that helps you pass the time.😝😜",
    language: "javascript",
    link: "https://harikarumuri.github.io/TryThis/",
    image:
      "https://www.rd.com/wp-content/uploads/2020/12/GettyImages-155278338-e1607021370174.jpg?fit=700,700",
  },
  {
    id: 7,
    title: "a hover app",
    des: "a simple project to include this functionality into a restaurant page.😋😋",
    language: "css",
    link: "https://harikarumuri.github.io/hoverTestSuccess/",
    image:
      "https://img.freepik.com/free-photo/big-hamburger-with-double-beef-french-fries_252907-8.jpg?w=2000",
  },
  {
    id: 8,
    title: "giffy api ",
    des: "a random gif generator ,,on every reload there will be a new gif🤡🤠 ",
    language: "javascript",
    link: "https://harikarumuri.github.io/usingApi/",
    image: "https://media.sproutsocial.com/uploads/2015/04/What-is-an-API.png",
  },
  {
    id: 9,
    title: "day / night changer",
    des: "a button that allowsu to change background ,a little project",
    language: "javascript",
    link: "https://harikarumuri.github.io/DayNight-project/",
    image:
      "https://st2.depositphotos.com/1000874/7064/i/600/depositphotos_70640587-stock-photo-field-green-field-in-day.jpg",
  },
];
export default Data;
